<template>
    <div class="footer__contacts">
        <div class="footer__contacts-item" style="max-width: 310px;">
            {{ company }}<br>
            {{ address }}, {{ country }}<br>
            Reg.: {{ regNum }}
        </div>
        <div class="footer__contacts-item mt-auto">
            Email: {{ mailTo }}
        </div>
        <div class="footer__contacts-item">
            Telephone: {{ phone }}
        </div>
    </div>
</template>

<script>
import config from '@/config'
export default {
    data() {
        return {
            company: config.company,
            address: config.address,
            country: config.country,
            regNum: config.regNum,
            phone: config.phone,
            mailTo: config.mailTo,
        };
    },
};
</script>
